(function() {
  'use strict';

  if (window.BilliardCityDesktopSidebarFlyout) return;
  window.BilliardCityDesktopSidebarFlyout = {
    initialized: true
  };

  var ROOT_SELECTOR = 'body:not(.template-password):not(.template-giftcard) [data-section-type="sidebar-section"] #SiteNav';
  var ITEM_SELECTOR = '.site-nav--has-submenu';
  var SUBMENU_SELECTOR = ':scope > .site-nav__submenu';
  var TRIGGER_SELECTOR = ':scope > .site-nav__link';
  var LAYER_SELECTOR = '[data-desktop-sidebar-flyout-layer]';
  var ACTIVE_CLASS = 'is-desktop-flyout-active';
  var PANEL_ACTIVE_CLASS = 'is-visible';
  var OPEN_DELAY = 50;
  var CLOSE_DELAY = 220;
  var MIN_PANEL_WIDTH = 190;
  var DEFAULT_PANEL_WIDTH = 230;
  var VIEWPORT_GAP = 8;

  var root = null;
  var layer = null;
  var activeSourceItems = [];
  var panels = [];
  var openTimer = 0;
  var closeTimer = 0;
  var isEnabled = false;
  var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null;
  var pointerQuery = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  var originalFocusEl = null;

  function matchesDesktop() {
    return Boolean(desktopQuery && pointerQuery && desktopQuery.matches && pointerQuery.matches);
  }

  function getRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function getDirectSubmenu(item) {
    if (!item) return null;
    try {
      return item.querySelector(SUBMENU_SELECTOR);
    } catch (error) {
      var children = item.children;
      for (var i = 0; i < children.length; i += 1) {
        if (children[i].classList && children[i].classList.contains('site-nav__submenu')) {
          return children[i];
        }
      }
    }
    return null;
  }

  function getDirectTrigger(item) {
    if (!item) return null;
    try {
      return item.querySelector(TRIGGER_SELECTOR);
    } catch (error) {
      var children = item.children;
      for (var i = 0; i < children.length; i += 1) {
        if (children[i].classList && children[i].classList.contains('site-nav__link')) {
          return children[i];
        }
      }
    }
    return null;
  }

  function getItemLabel(item) {
    var label = item ? item.querySelector(':scope > .site-nav__link .site-nav__label') : null;
    var trigger = getDirectTrigger(item);
    return (label || trigger || item).textContent.replace(/[+\-]/g, '').replace(/\s+/g, ' ').trim();
  }

  function ensureLayer() {
    if (layer && document.body.contains(layer)) return layer;
    layer = document.querySelector(LAYER_SELECTOR);
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'desktop-sidebar-flyout-layer';
      layer.setAttribute('data-desktop-sidebar-flyout-layer', '');
      document.body.appendChild(layer);
    }
    return layer;
  }

  function removeLayer() {
    if (layer && layer.parentNode) {
      layer.parentNode.removeChild(layer);
    }
    layer = null;
  }

  function clearTimer(timerId) {
    if (timerId) window.clearTimeout(timerId);
    return 0;
  }

  function cancelClose() {
    closeTimer = clearTimer(closeTimer);
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = window.setTimeout(closeAll, CLOSE_DELAY);
  }

  function clearOpenTimer() {
    openTimer = clearTimer(openTimer);
  }

  function setRootIndicator(item, isOpen) {
    var trigger = getDirectTrigger(item);
    var indicator = trigger ? trigger.querySelector('.site-nav__link__text') : null;
    if (indicator) indicator.textContent = isOpen ? '-' : '+';
  }

  function clearActiveFromLevel(level) {
    for (var i = level; i < activeSourceItems.length; i += 1) {
      if (activeSourceItems[i]) {
        activeSourceItems[i].classList.remove(ACTIVE_CLASS);
        if (activeSourceItems[i].parentNode && activeSourceItems[i].parentNode.classList && activeSourceItems[i].parentNode.classList.contains('list--nav')) {
          setRootIndicator(activeSourceItems[i], false);
        }
      }
    }
    activeSourceItems.length = level;

    for (var j = panels.length - 1; j >= level; j -= 1) {
      if (panels[j] && panels[j].parentNode) {
        panels[j].parentNode.removeChild(panels[j]);
      }
      panels.pop();
    }
  }

  function closeAll() {
    clearOpenTimer();
    cancelClose();
    clearActiveFromLevel(0);
    originalFocusEl = null;
  }

  function deactivate() {
    closeAll();
    if (root) {
      root.removeEventListener('mouseover', onRootMouseOver, true);
      root.removeEventListener('mouseout', onRootMouseOut, true);
      root.removeEventListener('focusin', onRootFocusIn, true);
      root.removeEventListener('focusout', onRootFocusOut, true);
      root.removeEventListener('click', onRootClick, true);
    }
    document.removeEventListener('keydown', onKeyDown, true);
    removeLayer();
    isEnabled = false;
  }

  function activate() {
    root = getRoot();
    if (!root || isEnabled || !matchesDesktop()) return;
    ensureLayer();
    root.addEventListener('mouseover', onRootMouseOver, true);
    root.addEventListener('mouseout', onRootMouseOut, true);
    root.addEventListener('focusin', onRootFocusIn, true);
    root.addEventListener('focusout', onRootFocusOut, true);
    root.addEventListener('click', onRootClick, true);
    layer.addEventListener('mouseover', onLayerMouseOver, true);
    layer.addEventListener('mouseout', onLayerMouseOut, true);
    layer.addEventListener('focusin', onLayerFocusIn, true);
    layer.addEventListener('focusout', onLayerFocusOut, true);
    layer.addEventListener('click', onLayerClick, true);
    document.addEventListener('keydown', onKeyDown, true);
    isEnabled = true;
  }

  function refresh() {
    if (matchesDesktop()) {
      activate();
    } else if (isEnabled || layer) {
      deactivate();
    }
  }

  function closestItemWithSubmenu(target, container) {
    var item = target && target.closest ? target.closest(ITEM_SELECTOR) : null;
    if (!item || (container && !container.contains(item))) return null;
    return getDirectSubmenu(item) ? item : null;
  }

  function onRootMouseOver(event) {
    if (!matchesDesktop()) return;
    var item = closestItemWithSubmenu(event.target, root);
    if (!item || item.contains(event.relatedTarget)) return;
    queueOpen(item, getDirectTrigger(item), 0);
  }

  function onRootMouseOut(event) {
    if (!matchesDesktop()) return;
    var item = closestItemWithSubmenu(event.target, root);
    if (!item || item.contains(event.relatedTarget)) return;
    if (layer && layer.contains(event.relatedTarget)) return;
    scheduleClose();
  }

  function onRootFocusIn(event) {
    if (!matchesDesktop()) return;
    var item = closestItemWithSubmenu(event.target, root);
    if (!item) return;
    originalFocusEl = originalFocusEl || getDirectTrigger(item);
    queueOpen(item, getDirectTrigger(item), 0);
  }

  function onRootFocusOut(event) {
    if (!matchesDesktop()) return;
    if (root.contains(event.relatedTarget) || (layer && layer.contains(event.relatedTarget))) return;
    scheduleClose();
  }

  function onRootClick(event) {
    if (!matchesDesktop()) return;
    var trigger = event.target.closest ? event.target.closest('.site-nav__link') : null;
    var item = trigger ? trigger.parentNode : null;
    if (!item || !item.matches || !item.matches(ITEM_SELECTOR) || !root.contains(item) || !getDirectSubmenu(item)) return;
    if (trigger.tagName && trigger.tagName.toLowerCase() === 'button') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openFromItem(item, trigger, 0);
    }
  }

  function onLayerMouseOut(event) {
    if (!layer || layer.contains(event.relatedTarget) || (root && root.contains(event.relatedTarget))) return;
    scheduleClose();
  }

  function onLayerMouseOver(event) {
    cancelClose();
    var row = getFlyoutRow(event.target);
    if (!row || row.contains(event.relatedTarget)) return;
    handleFlyoutRowEnter(row);
  }

  function onLayerFocusIn(event) {
    cancelClose();
    var row = getFlyoutRow(event.target);
    if (!row) return;
    handleFlyoutRowEnter(row);
  }

  function onLayerFocusOut(event) {
    if (!layer || layer.contains(event.relatedTarget) || (root && root.contains(event.relatedTarget))) return;
    scheduleClose();
  }

  function onLayerClick(event) {
    var row = getFlyoutRow(event.target);
    var sourceItem = row ? row.__desktopSidebarSourceItem : null;
    if (!sourceItem || !getDirectSubmenu(sourceItem)) return;
    event.preventDefault();
    handleFlyoutRowEnter(row);
  }

  function getFlyoutRow(target) {
    if (!target || !target.closest || !layer) return null;
    var row = target.closest('.desktop-sidebar-flyout__item');
    return row && layer.contains(row) ? row : null;
  }

  function handleFlyoutRowEnter(row) {
    var panel = row.closest('[data-desktop-sidebar-flyout-panel]');
    var level = panel ? parseInt(panel.getAttribute('data-flyout-level'), 10) : NaN;
    var sourceItem = row.__desktopSidebarSourceItem;
    var sourceSubmenu = getDirectSubmenu(sourceItem);

    if (!panel || isNaN(level) || !sourceItem) return;

    setPanelItemActive(panel, row);
    if (sourceSubmenu) {
      queueOpen(sourceItem, row, level + 1);
    } else {
      clearOpenTimer();
      clearActiveFromLevel(level + 1);
    }
  }

  function onKeyDown(event) {
    if (!isEnabled || (event.key !== 'Escape' && event.keyCode !== 27)) return;
    if (!activeSourceItems.length) return;
    event.preventDefault();
    var focusTarget = originalFocusEl || getDirectTrigger(activeSourceItems[0]);
    closeAll();
    if (focusTarget && focusTarget.focus) focusTarget.focus();
  }

  function queueOpen(item, anchor, level) {
    cancelClose();
    clearOpenTimer();
    openTimer = window.setTimeout(function() {
      openFromItem(item, anchor, level);
    }, OPEN_DELAY);
  }

  function openFromItem(item, anchor, level) {
    var submenu = getDirectSubmenu(item);
    if (!submenu || !matchesDesktop()) return;
    ensureLayer();
    clearActiveFromLevel(level);

    item.classList.add(ACTIVE_CLASS);
    activeSourceItems[level] = item;
    if (item.parentNode && item.parentNode.classList && item.parentNode.classList.contains('list--nav')) {
      setRootIndicator(item, true);
    }

    var panel = buildPanel(submenu, level);
    if (!panel) return;
    layer.appendChild(panel);
    panels[level] = panel;
    positionPanel(panel, anchor, level);
    window.requestAnimationFrame(function() {
      panel.classList.add(PANEL_ACTIVE_CLASS);
    });
  }

  function buildPanel(submenu, level) {
    var children = [];
    for (var i = 0; i < submenu.children.length; i += 1) {
      if (submenu.children[i].tagName && submenu.children[i].tagName.toLowerCase() === 'li') {
        children.push(submenu.children[i]);
      }
    }
    if (!children.length) return null;

    var panel = document.createElement('div');
    panel.className = 'desktop-sidebar-flyout';
    panel.setAttribute('data-desktop-sidebar-flyout-panel', '');
    panel.setAttribute('data-flyout-level', String(level));

    var list = document.createElement('ul');
    list.className = 'desktop-sidebar-flyout__list';
    panel.appendChild(list);

    children.forEach(function(sourceItem) {
      var row = document.createElement('li');
      var sourceSubmenu = getDirectSubmenu(sourceItem);
      var sourceLink = getDirectTrigger(sourceItem);
      var isLink = sourceLink && sourceLink.tagName && sourceLink.tagName.toLowerCase() === 'a';
      var control = document.createElement(isLink ? 'a' : 'button');
      var label = document.createElement('span');
      var indicator = document.createElement('span');

      row.className = 'desktop-sidebar-flyout__item';
      row.__desktopSidebarSourceItem = sourceItem;

      control.className = 'desktop-sidebar-flyout__link';
      if (isLink) {
        control.href = sourceLink.getAttribute('href') || '#';
        if (sourceLink.getAttribute('aria-current')) {
          control.setAttribute('aria-current', sourceLink.getAttribute('aria-current'));
        }
      } else {
        control.type = 'button';
      }

      label.className = 'desktop-sidebar-flyout__label';
      label.textContent = getItemLabel(sourceItem);
      control.appendChild(label);

      indicator.className = 'desktop-sidebar-flyout__indicator';
      indicator.setAttribute('aria-hidden', 'true');
      indicator.textContent = sourceSubmenu ? '\u203A' : '';
      control.appendChild(indicator);

      row.appendChild(control);
      list.appendChild(row);
    });

    return panel;
  }

  function setPanelItemActive(panel, row) {
    var rows = panel.querySelectorAll('.desktop-sidebar-flyout__item');
    for (var i = 0; i < rows.length; i += 1) {
      rows[i].classList.toggle(ACTIVE_CLASS, rows[i] === row);
    }
  }

  function getPanelWidth(level) {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1024;
    var desired = Math.max(210, Math.min(DEFAULT_PANEL_WIDTH, Math.round(viewportWidth * 0.15)));
    var remaining = viewportWidth - VIEWPORT_GAP - (level * (MIN_PANEL_WIDTH - 1));
    return Math.max(MIN_PANEL_WIDTH, Math.min(desired, remaining));
  }

  function positionPanel(panel, anchor, level) {
    if (!panel || !anchor) return;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var anchorRect = anchor.getBoundingClientRect();
    var width = getPanelWidth(level);
    var previousPanel = level > 0 ? panels[level - 1] : null;
    var previousPanelRect = previousPanel ? previousPanel.getBoundingClientRect() : null;
    var left = previousPanelRect ? previousPanelRect.right - 1 : anchorRect.right - 1;

    if (left + width > viewportWidth - VIEWPORT_GAP) {
      width = Math.max(MIN_PANEL_WIDTH, viewportWidth - left - VIEWPORT_GAP);
    }

    panel.style.width = width + 'px';
    panel.style.left = Math.round(left) + 'px';
    panel.style.top = '0px';
    panel.style.maxHeight = Math.max(180, viewportHeight - (VIEWPORT_GAP * 2)) + 'px';

    var wantedHeight = Math.min(panel.scrollHeight, viewportHeight - (VIEWPORT_GAP * 2));
    var top = anchorRect.top;
    var maxTop = Math.max(VIEWPORT_GAP, viewportHeight - wantedHeight - VIEWPORT_GAP);
    top = Math.min(Math.max(top, VIEWPORT_GAP), maxTop);
    panel.style.top = Math.round(top) + 'px';
  }

  function bindQuery(query) {
    if (!query) return;
    if (query.addEventListener) {
      query.addEventListener('change', refresh);
    } else if (query.addListener) {
      query.addListener(refresh);
    }
  }

  function init() {
    root = getRoot();
    refresh();
    bindQuery(desktopQuery);
    bindQuery(pointerQuery);
    document.addEventListener('shopify:section:load', function() {
      deactivate();
      root = getRoot();
      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
